module.exports = __webpack_public_path__ + "img/12.056cfa87.jpg";